import { BaseLinkPreviewObject, LinkPreviewType } from './BaseLinkPreviewObject';
import { updateVideoLinkPreviewSize, VideoLinkPreviewObject } from './VideoLinkPreviewObject';
import { updateWebpageLinkPreviewSize, WebpageLinkPreviewObject } from './WebpageLinkPreviewObject';

export enum PreviewSize {
    Standard,
    Compact,
    Default,
}

export function updatePreviewSize(linkPreview: BaseLinkPreviewObject, previewSize: PreviewSize) {
    if (linkPreview) {
        switch (linkPreview.type) {
            case LinkPreviewType.WebpagePreview:
                return updateWebpageLinkPreviewSize(
                    <WebpageLinkPreviewObject>linkPreview,
                    previewSize
                );
            case LinkPreviewType.VideoPreview:
                return updateVideoLinkPreviewSize(<VideoLinkPreviewObject>linkPreview, previewSize);
        }
    }
}
